import React, { memo } from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import XPBar from '../components/XPBar';
import XPToast from '../components/XPToast';
import LevelUpOverlay from '../components/LevelUpOverlay';


const Layout = ({ children }) => {
  return (
    <div className="casino-app">
      <TopBar />
      <XPBar />
      <div className="main-layout">
        <Sidebar />
        <main className="content">
          {children}
        </main>
      </div>
      <XPToast />
      <LevelUpOverlay />
    </div>
  );
};

export default memo(Layout);
